<template>
    <div
        class="visualization provider-sankey-visualization"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <div class="row">
            <div class="col-sm-10">
                <el-radio-group v-model="periodo">
                    <el-radio-button
                        v-for="p in periodos"
                        :key="p"
                        :label="p"
                    ></el-radio-button>
                </el-radio-group>
            </div>
            <div class="col-sm-2 text-right">
                <div class="mode-selector" v-show="details === null">
                    <span class="title">Ver como</span>
                    <div class="view-buttons">
                        <el-tooltip content="Gráfico">
                            <a
                                href="#"
                                @click.prevent="mode = 'chart'"
                                :class="{ active: mode === 'chart' }"
                            >
                                <i class="material-icons">dashboard</i>
                            </a>
                        </el-tooltip>
                        <el-tooltip content="Tabla">
                            <a
                                href="#"
                                @click.prevent="mode = 'table'"
                                :class="{ active: mode === 'table' }"
                            >
                                <i class="material-icons">view_list</i>
                            </a>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="!loading && data.length">
            <div v-show="mode === 'chart'">
                <sankey-chart
                    v-show="details === null"
                    :data="hierarchicalData"
                    :dimensions="dimensions"
                    @detail-clicked="detailClicked"
                ></sankey-chart>
                <div v-show="details !== null">
                    <div>
                        <a href="#" @click.prevent="details = null"
                            >&lt; Volver al gráfico</a
                        >
                    </div>
                    <expenses-detail-visualization
                        :where="detailWhere"
                        ref="detailViz"
                    ></expenses-detail-visualization>
                </div>
            </div>

            <table-chart
                :height="510"
                :data="data"
                v-show="mode === 'table'"
            ></table-chart>
        </template>
        <p v-else>No hay datos</p>

        <visualization-footer :url="this.url"></visualization-footer>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import SankeyChart from '../Charts/Sankey';
import TableChart from '../Charts/Table';
import ExpensesDetailVisualization from './ExpensesDetail';
import VisualizationFooter from './Common/Footer';

export default {
    data: function() {
        return {
            periodo: this.$store.state.defaultYear,
            periodos: [],
            loading: false,
            data: [],
            dimensions: { ordinal: ['partida', 'capitulo', 'area'] },
            mode: 'chart',
            details: null
        };
    },
    props: ['where'],
    components: {
        SankeyChart,
        TableChart,
        ExpensesDetailVisualization,
        VisualizationFooter
    },
    watch: {
        periodo: function(value) {
            this.$store.commit('setDefaultYear', value);
            this.refreshData();
        }
    },
    methods: {
        assign: _.assign,
        clone: _.clone,
        detailClicked: function(n) {
            this.details = {};
            const segments = n.data.id.split('/');
            if (segments[0]) this.details.partida = segments[0];
            if (segments[1]) this.details.capitulo = segments[1];
            if (segments[2]) this.details.area = segments[2];

            //this.$nextTick(()=>{
            //    this.$refs.detailViz.refreshData();
            //});
        },
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;
                this.data = response.data;
            });
        }
    },
    computed: {
        detailWhere: function() {
            return _.assign(_.clone(this.computedWhere), this.details);
        },
        computedWhere: function() {
            return _.assign(_.clone(this.where), { periodo: this.periodo });
        },
        url: function() {
            return (
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify(['partida', 'capitulo', 'area']) +
                '&where=' +
                JSON.stringify(this.computedWhere)
            );
        },
        hierarchicalData: function() {
            return {
                id: '',
                type: 'pais',
                name: 'GOBIERNO CENTRAL',
                children: _(this.data)
                    .groupBy('partida')
                    .map(function(p) {
                        return {
                            id: p[0].partida,
                            type: 'partida',
                            name: p[0].nombre_partida,
                            children: _(p)
                                .groupBy('capitulo')
                                .map(function(c) {
                                    return {
                                        id: p[0].partida + '/' + c[0].capitulo,
                                        type: 'capitulo',
                                        name: c[0].nombre_capitulo,
                                        children: _(c)
                                            .map(function(a) {
                                                return {
                                                    id:
                                                        p[0].partida +
                                                        '/' +
                                                        c[0].capitulo +
                                                        '/' +
                                                        a.area,
                                                    type: 'area',
                                                    name: a.nombre_area,
                                                    size: a.sum
                                                };
                                            })
                                            .value()
                                    };
                                })
                                .value()
                        };
                    })
                    .value()
            };
        }
    },
    mounted: function() {
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/ProviderSankey.vue